import React from 'react';
import { ReadMore } from '@reverse-hr/design-system';
import { useTranslation } from 'react-i18next';

const Summary = props => {
  const { summary, isReadMoreEnabled } = props;
  const { t } = useTranslation();

  const renderSummary = () =>
    isReadMoreEnabled ? (
      <ReadMore
        className="c-app-showcase__summary"
        showLessContent={t('showcase.summary.hide')}
        showMoreContent={t('showcase.summary.readmore')}
        visibleLines={SUMMARY_VISIBLE_LINES}
      >
        {summary}
      </ReadMore>
    ) : (
      <div className="c-app-showcase__summary">{summary}</div>
    );

  return <td className="c-app-showcase__cell">{renderSummary()}</td>;
};

export default Summary;

const SUMMARY_VISIBLE_LINES = 3;
